'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _requestError = require('@setapp/request-error');

var _requestError2 = _interopRequireDefault(_requestError);

var _signupMetadata = require('@setapp/signup-metadata');

var _signupMetadata2 = _interopRequireDefault(_signupMetadata);

var _humps = require('humps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Authenticator = function () {
  function Authenticator(options) {
    (0, _classCallCheck3.default)(this, Authenticator);

    this.options = {
      apiRoot: options.apiRoot,
      cookiesDomain: options.cookiesDomain,
      tokenManager: options.tokenManager
    };

    this.metadata = new _signupMetadata2.default({ cookiesDomain: this.options.cookiesDomain });
  }

  (0, _createClass3.default)(Authenticator, [{
    key: 'signUp',
    value: function signUp(data, options) {
      var _this = this;

      var metaData = this.metadata.getAll();

      var payload = (0, _extends3.default)({}, metaData, data);

      return fetch(this.options.apiRoot + '/me', {
        method: 'POST',
        body: (0, _stringify2.default)((0, _humps.decamelizeKeys)(payload)),
        headers: {
          'Accept': 'application/json',
          'Content-type': 'application/json',
          'Accept-Language': options.language
        }
      }).then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () {
            return _promise2.default.reject(_requestError2.default.create(response));
          }).then(function (errorJson) {
            return _promise2.default.reject(_requestError2.default.create(response, errorJson));
          });
        }

        return response.json();
      }).then(function (response) {
        return _this._onSignUpSuccess((0, _humps.camelizeKeys)(response.data));
      });
    }
  }, {
    key: '_onSignUpSuccess',
    value: function _onSignUpSuccess(response) {
      var accessToken = response.token,
          refreshToken = response.refreshToken;


      this.options.tokenManager.saveTokens({
        accessToken: accessToken,
        refreshToken: refreshToken
      });
      this.metadata.cleanAll();

      return response;
    }
  }]);
  return Authenticator;
}();

exports.default = Authenticator;
//# sourceMappingURL=authenticator.js.map